import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderRelatedTaxiRailyItem from "./billings-order-related-taxi-raily";
import BillingsOrderRelatedTaxiRailyParams from "./billings-order-related-taxi-raily-params";

const useBillingsOrderRelatedTaxiRaily = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderRelatedTaxiRailyItem[]>([]);

  const load = async (
    params: BillingsOrderRelatedTaxiRailyParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.getOrderRelatedTaxiRailyBillings(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderRelatedTaxiRaily;
